module.exports = __webpack_public_path__ + "img/computing.8188abed.png";